import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../apiCalls/rtkBaseQuery';
import { LIST_DG_REVIEW } from '../../../apiCalls/urls/dgReview';
import { GET_LIST } from '../../../apiCalls/urls/common';

export const dgReviewApi = createApi({
    baseQuery,
    tagTypes: ['dgReview'],
    reducerPath: 'dgReviewApi',
    endpoints: (builder) => ({
        getDGReviewList: builder.query({
            query: (bodyData) => ({
                url: LIST_DG_REVIEW,
                method: 'POST',
                body: bodyData || {}
            }),
            providesTags: ['dgReview'],
            refetchOnMountOrArgChange: true,
        }),
        getList: builder.mutation({
            query: (bodyData) => ({
                url: GET_LIST,
                method: 'POST',
                body: bodyData || {}
            }),
            refetchOnMountOrArgChange: false,
        })
    }),
});

export const {
    useGetDGReviewListQuery,
    useGetListMutation
} = dgReviewApi;